"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Error = void 0;
var widgets_1 = require("@tableau/widgets");
var AlertStyles_1 = require("@tableau/widgets/lib/src/widgets/AlertStyles");
var React = require("react");
var LayoutStyles_1 = require("../../styles/LayoutStyles");
var Error = function (props) {
    var _a, _b, _c, _d, _e;
    var cssStyle = {
        width: (_b = (_a = props.style) === null || _a === void 0 ? void 0 : _a.width) !== null && _b !== void 0 ? _b : '400px',
        justifyContent: (_d = (_c = props.style) === null || _c === void 0 ? void 0 : _c.justifyContent) !== null && _d !== void 0 ? _d : 'initial',
    };
    var type = (_e = props.type) !== null && _e !== void 0 ? _e : AlertStyles_1.AlertType.Error;
    return (React.createElement("div", { className: LayoutStyles_1.ErrorContainer, style: cssStyle },
        React.createElement(widgets_1.CompactInlineAlertWidget, { testId: props.testId, type: type },
            props.message,
            ' ',
            props.retry && (React.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.Outline, onClick: props.retry.onClick }, props.retry.label)))));
};
exports.Error = Error;
//# sourceMappingURL=Error.js.map